import React from 'react';
import { CheckCircle, XCircle, AlertCircle, Info } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import './Toast.css';

const icons = { success: CheckCircle, error: XCircle, warning: AlertCircle, info: Info };
const colors = { success: 'var(--success)', error: 'var(--danger)', warning: 'var(--warning)', info: 'var(--info)' };

export default function Toast() {
  const { toast } = useApp();
  if (!toast) return null;
  const Icon = icons[toast.type] || CheckCircle;
  return (
    <div className="toast-wrap">
      <div className={`toast toast-${toast.type}`}>
        <Icon size={16} style={{ color: colors[toast.type], flexShrink: 0 }} />
        <span>{toast.message}</span>
      </div>
    </div>
  );
}
